import React, { useState, useEffect, useRef, useContext } from "react";
import { Container } from "components";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "components/molecules/Breadcrumb";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { postData, putData } from "actions";
import { API_URL_ticketStatus } from "constants/api";
import { ticketStatusReducers } from "redux/ticketStatusSlice";

import { AuthContext } from "context/AuthContext";

const FormStatus = ({ typeForm }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();
  const inputRefs = useRef([]);

  const formik = useFormik({
    initialValues: {
      name: location.state ? location.state.item.name : "",
      sort: location.state ? location.state.item.sort : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
    }),
    onSubmit: (values) => {
      const formData = values;
      if (location.state === null) {
        postData(
          API_URL_ticketStatus,
          formData,
          { dispatch, redux: ticketStatusReducers },
          "ADD_TICKETSTATUS",
          () => {
            navigate("/administrator/tickets/status");
          }
        );
      } else {
        putData(
          `${API_URL_ticketStatus}${location.state.item.id}/`,
          formData,
          { dispatch, redux: ticketStatusReducers },
          "ADD_TICKETSTATUS",
          () => {
            navigate("/administrator/tickets/status");
          }
        );
      }
    },
  });

  // Focus Input validate & submit
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    await formik.validateForm();
    const firstInvalidInputRef = inputRefs.current.find((inputRef) => {
      const fieldName = inputRef.name;
      formik.setFieldTouched(fieldName, true, true);
      return formik.errors[fieldName];
    });
    if (firstInvalidInputRef) {
      firstInvalidInputRef.focus();
    } else {
      formik.handleSubmit();
    }
  };

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Status settings"}
        excludedPaths={["tickets", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
          Edit details
        </div>
        <form onSubmit={handleFormSubmit}>
          <div className="h-auto w-auto px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
            <div className="mt-4">
              <div className="mt-4 grid grid-cols-12 gap-3">
                <div className="col-span-full mb-1.5 md:col-span-4 md:col-start-1 lg:col-span-4 lg:col-start-1">
                  <label className="text-xs mr-1 md:-text-sm lg:text-sm">
                    Nama <span className="text-red-500">*</span>
                  </label>
                  <div>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      ref={(ref) => (inputRefs.current[0] = ref)}
                      className="block w-full rounded-md border border-gray-500 bg-white py-1.5 px-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-blue-400 text-xs md:-text-sm lg:text-sm sm:leading-6"
                    />

                    {formik.touched.name && formik.errors.name && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.name}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-span-full mb-1.5 md:col-span-4 md:col-start-5 lg:col-span-4 lg:col-start-5">
                  <label className="text-xs mr-1 md:-text-sm lg:text-sm">
                    Display order <span className="text-red-500">*</span>
                  </label>
                  <div>
                    <input
                      type="number"
                      name="sort"
                      id="sort"
                      value={formik.values.sort}
                      onChange={formik.handleChange}
                      ref={(ref) => (inputRefs.current[1] = ref)}
                      className="block w-full rounded-md border border-gray-500 bg-white py-1.5 px-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-blue-400 text-xs md:-text-sm lg:text-sm sm:leading-6"
                    />
                    {formik.touched.sort && formik.errors.sort && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.sort}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
            <button
              type="submit"
              className="w-20 items-center p-1 px-3 rounded shadow-sm border text-white bg-blue-800 hover:bg-blue-700"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </Container>
  );
};

export default FormStatus;
